import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { PopupContactComponent } from './popup-contact.component';
@Component({
  selector: 'app-adfooter',
  templateUrl: './adfooter.component.html',
  providers: [PopupContactComponent]
})
export class adFooterComponent implements OnInit {

  constructor( private dialogService: DialogService) { }

  ngOnInit() {
  }

showPopUp(){
    let disposable = this.dialogService.addDialog(PopupContactComponent, {
            title: 'Contact Information',
            message: ''
        })
            .subscribe((isConfirmed) => {
                //We get dialog result
                if (isConfirmed) {

                }
                else {
                }
            });
}

}



// WEBPACK FOOTER //
// ./src/app/common/adfooter.component.ts